module.exports = ".hide {\n    display: none;\n}\n\n/* .chat-container-con .in-con>span {\n    background-color: transparent !important;\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/help-guide/help-guide.component.css
// module id = ./src/app/shared/component/help-guide/help-guide.component.css
// module chunks = main